import * as React from 'react'

export function SettingsAppleWatch(props) {
  return (
    <svg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M24.846 11c.637 0 1.154.517 1.154 1.154v1.692c0 .637-.517 1.154-1.154 1.154H24v7c0 1.65-1.35 3-3 3H11c-1.65 0-3-1.35-3-3V10c0-1.65 1.35-3 3-3h10c1.65 0 3 1.35 3 3v1h.846zM22 22V10c0-.542-.458-1-1-1H11c-.542 0-1 .458-1 1v12c0 .542.458 1 1 1h10c.542 0 1-.458 1-1zm-1.5-12a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5h9zm-8.524 19.278L11 26h10l-.976 3.277c-.128.43-.517.723-.956.723h-6.133c-.44 0-.829-.293-.957-.723zm8.047-26.555L21 6H11l.976-3.277c.13-.43.517-.723.957-.723h6.133c.44 0 .828.293.957.723z'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  )
}
